<script>
  import Image from "./Image.svelte";

  export let text = undefined;
  export let icon = undefined;
  export let fa = true;
  export let iconSize = "auto";
  export let iconColor = "var(--primary-light-color)";
  export let iconLeft = true;
  export let size = "inherit";
  export let color = undefined;
  export let cursor = "inherit";
  export let selected = false;
  export let borderLeft = false;
  export let borderRight = false;
  export let h = "1em";
  export let nowrap = true;
  export let tooltip = false;
  export let noshrink = false;
  export let selection = undefined;
  export let copy = false;

  let copied = false;

  let indexSelection = -1;

  function refreshSelection(selection, text) {
    if (selection && text) {
      indexSelection = text.toLowerCase().indexOf(selection.toLowerCase());
    } else {
      indexSelection = -1;
    }
  }

  $: refreshSelection(selection, text);

  function doCopy(e) {
    e.stopPropagation();
    console.log(e);
    navigator.clipboard.writeText(text).then(
      () => {
        console.log("copié");
        copied = true;
        tooltip = "Copié";
      },
      () => {
        console.log("copy failed");
      }
    );
  }
</script>

<article
  class:borderRight
  class:borderLeft
  class:nowrap
  class:noshrink
  class:tooltip
  style="font-size:{size}px; color:{color}; cursor:{cursor}; height:{h};"
  data-tooltip={tooltip}>
  {#if iconLeft && icon}
    {#if fa}
      <i
        aria-hidden="true"
        style="color:{iconColor}"
        class="fas fa-{icon}"
        class:selected
        on:click />
    {:else}
      <Image src={icon} width={iconSize} height={iconSize} />
    {/if}
  {/if}

  {#if text}
    <div class:iconLeft={iconLeft && icon}>
      {#if indexSelection > -1}
        <span>
          {text.slice(0, indexSelection)}
          <mark>
            {text.slice(indexSelection, indexSelection + selection.length)}
          </mark>{text.slice(indexSelection + selection.length)}
        </span>
      {:else}
        <span>{text}</span>
      {/if}
    </div>
  {/if}

  {#if !iconLeft && icon}
    {#if fa}
      <i
        aria-hidden="true"
        style="color:{iconColor}"
        class="fas fa-{icon}"
        class:selected
        on:click />
    {:else}
      <Image src={icon} width={iconSize} height={iconSize} />
    {/if}
  {/if}
  {#if copy}
    <i aria-hidden="true" style="color:{iconColor}" class="fas fa-copy copy" on:click={doCopy} />
  {/if}
</article>

<style>
  article {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    margin: 0;
    padding: 0 0.5em 0 0.5em;
    white-space: nowrap;
    text-overflow: clip;
    width: fit-content;
  }

  article.nowrap {
    flex-wrap: nowrap;
  }
  article.borderRight {
    border-right: 1px solid;
    border-color: var(--primary-light-color);
  }
  article.borderLeft {
    border-left: 1px solid;
    border-color: var(--primary-light-color);
  }

  mark {
    background-color: #b3d4ff;
  }

  i {
    line-height: unset;
    min-width: 20px;
    text-align: center;
  }
  i.selected {
    color: white;
  }

  i.copy {
    visibility: hidden;
  }

  article:hover i.copy {
    visibility: visible;
  }

  div {
    flex-wrap: wrap;
    min-width: 0;
    margin-right: 0.5em;
    user-select: none;
    position: relative;
    text-overflow: clip;
    line-height: 1em;
    display: flex;
    align-items: center;
  }

  div.iconLeft {
    margin-left: 0.5em;
    margin-right: 0;
  }

  @media screen and (max-width: 480px) {
    article:not(.noshrink) span {
      display: none;
    }
    :not(.noshrink) i.fas {
      margin-right: 0px;
    }
  }
</style>
